import { OrderStatus } from "@/graphql/codegen/graphql"
import type { POActionNames } from "@/screens/Procurement/PurchaseOrder/constants"

export const CANCELABLE_STATUSES = [
  OrderStatus.Draft,
  OrderStatus.Quote,
  OrderStatus.Sent,
  OrderStatus.Confirmed,
  OrderStatus.PartiallyReceived,
  OrderStatus.PartiallyShipped,
  OrderStatus.Shipped,
  OrderStatus.Received,
] as const
export const EDITABLE_STATUSES = [
  OrderStatus.Draft,
  OrderStatus.Quote,
  OrderStatus.Sent,
  OrderStatus.Confirmed,
  OrderStatus.PartiallyReceived,
  OrderStatus.PartiallyShipped,
  OrderStatus.Shipped,
  OrderStatus.Received,
] as const
export const SENDABLE_STATUSES = [OrderStatus.Draft, OrderStatus.Quote] as const
export const RESENDABLE_STATUSES = [
  OrderStatus.Sent,
  OrderStatus.Confirmed,
  OrderStatus.PartiallyReceived,
  OrderStatus.PartiallyShipped,
  OrderStatus.Shipped,
  OrderStatus.Received,
] as const
export const CLONABLE_STATUSES = [
  OrderStatus.Draft,
  OrderStatus.Sent,
  OrderStatus.Confirmed,
  OrderStatus.Completed,
  OrderStatus.PartiallyReceived,
  OrderStatus.PartiallyShipped,
  OrderStatus.Shipped,
  OrderStatus.Received,
] as const
export const PRINTABLE_STATUSES = [
  OrderStatus.Quote,
  OrderStatus.Sent,
  OrderStatus.Confirmed,
  OrderStatus.Completed,
  OrderStatus.PartiallyReceived,
  OrderStatus.PartiallyShipped,
  OrderStatus.Shipped,
  OrderStatus.Received,
] as const
export const DOWNLOADABLE_STATUSES = [
  OrderStatus.Quote,
  OrderStatus.Sent,
  OrderStatus.Confirmed,
  OrderStatus.Completed,
  OrderStatus.PartiallyReceived,
  OrderStatus.PartiallyShipped,
  OrderStatus.Shipped,
  OrderStatus.Received,
  OrderStatus.Cancelled,
  OrderStatus.CanceledQuote,
] as const
export const QUOTE_REQUESTABLE_STATUSES = [OrderStatus.Draft, OrderStatus.Quote] as const
export const PREVIEWABLE_STATUSES = [OrderStatus.Draft, OrderStatus.Quote] as const

// Read-only statuses for AK-3561: Cancelled, Complete, and Quote Cancelled
export const READONLY_STATUSES = [OrderStatus.Cancelled, OrderStatus.Completed, OrderStatus.CanceledQuote] as const

export type CancelableStatus = (typeof CANCELABLE_STATUSES)[number]
export type EditableStatus = (typeof EDITABLE_STATUSES)[number]
export type SendableStatus = (typeof SENDABLE_STATUSES)[number]
export type ResendableStatus = (typeof RESENDABLE_STATUSES)[number]
export type ClonableStatus = (typeof CLONABLE_STATUSES)[number]
export type PrintableStatus = (typeof PRINTABLE_STATUSES)[number]
export type DownloadableStatus = (typeof DOWNLOADABLE_STATUSES)[number]
export type ReadonlyStatus = (typeof READONLY_STATUSES)[number]
export type QuoteRequestableStatus = (typeof QUOTE_REQUESTABLE_STATUSES)[number]
export type PreviewableStatus = (typeof PREVIEWABLE_STATUSES)[number]

export interface ActionButton {
  label: POActionNames
  onClick?: () => void
  disabled?: boolean
  visible?: boolean
}
